<template>
  <div class="shippedRefund">

    <van-sticky>
      <van-nav-bar
        :style="{ 'paddingTop':statusBarHeight,'backgroundColor': '#FFFFFF' }"
        title="选择售后类型"
        left-arrow
        @click-left="handleBack"
      />
    </van-sticky>

    <main class="main">
      <div class="commodity">
        <h3>退款商品</h3>
        <div class="con">
          <div class="cover">
            <van-image fit="contain" :src="goodsDetails.picUrl" />
          </div>
          <div class="synopsis">
            <h4>{{goodsDetails.name}}</h4>
            <div class="price">¥ {{goodsDetails.salePrice}}</div>
            <div class="quantity">x{{goodsDetails.saleCount?goodsDetails.saleCount:1}}</div>
          </div>
        </div>
      </div>
      <div class="type">
        <h3>选择服务类型</h3>
        <div class="refund" @click="goRefund(0)">
          <div>仅退款</div>
          <img src="../asset/images/right.png" alt="">
        </div>
        <div class="salesReturn" @click="goRefund(1)">
          <div>退货退款</div>
          <img src="../asset/images/right.png" alt="">
        </div>
      </div>
    </main>

  </div>
</template>

<script>
export default {
  name: "shippedRefund",
  data() {
    return {
      id: this.$route.query.id,
      orderId: this.$route.query.orderId,
      orderNo: this.$route.query.orderNo,
      goodsDetails: {},
      statusBarHeight: 0,
      bottomSafeHeight: 0
    };
  },
  mounted() {
    this.setCompatible();
    this.combinationGoodsDetail();
  },
  methods: {
    setCompatible() {
      if(localStorage.getItem('type') == 'iOS') {
        this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
        this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
      }
    },
    combinationGoodsDetail() {
      // if(this.$route.query.url=='combinedOrderDetail'){
      //   const params = {
      //     id: this.id
      //   }
      //   this.$api.activities
      //     .combinationGoodsDetail({ params })
      //     .then((res) => {
      //       if (res.success) {
      //         this.goodsDetails = res.data;
      //       }
      //   });
      // }else if(this.$route.query.url=='orderDetail'){
        const data = {
          orderNo: this.orderNo,
        }
        this.$api.applyRefund
          .getEntityGoodOrderDetail(data)
          .then((res) => {
            if (res.success) {
              this.goodsDetails = res.data.goodsList[0];
              this.goodsDetails.realPay = res.data.realPay;
            }
        });
      // }
    },
    goRefund(type) {
      this.$router.push({
        path: '/submitRefund',
        query: {
          type: type,
          id: this.id,
          orderId: this.orderId,
          orderNo: this.orderNo,
          url: this.$route.query.url,
          source: 'shippedRefund',
          backPath:this.$route.query.backPath
        }
      })
    },
    handleBack() {
      this.$router.go(-1);
      // this.$router.push({
      //   name: this.$route.query.url,
      //   params: {
      //     type: this.$route.query.url=='combinedOrderDetail'?5:this.$route.query.url=='orderDetail'?3:'',
      //     orderNo: this.orderNo,
      //   }
      // })
    }
  },
};
</script>

<style lang="less" scoped>
@import "../asset/css/shippedRefund.less";
</style>